import i18n from 'i18next'
import fp from 'lodash/fp'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withFormModel, withMobxAutorun } from 'shared/hooks'
import { StoreContext } from 'store/context'
import { ServicesContext } from 'services/context'
import { spec, validators } from 'utils/validation'

import { toOptions } from './helpers'
import EventsFiltersComponent from './component'

export const EventsFilters = combine({
  hocs: [withRouter],
  hooks: [
    withContext(
      'tournamentsStore',
      StoreContext,
      ({ tournaments }) => tournaments
    ),

    withContext(
      'tournamentService',
      ServicesContext,
      ({ tournamentService }) => tournamentService
    ),

    withFormModel(
      (_state, { location }) => {
        const { es: eventSearch } = queryString.parse(location.search)

        return {
          search: {
            initialValue: eventSearch || '',
            spec: spec.flow(validators.any.required),
          },

          linkedSportTournament: {
            initialValue: '',
            spec: spec.flow(validators.any.required),
          },
        }
      },
      { id: 'events-filters-form' }
    ),

    // TODO: will be changes as soon as endpoints are ready
    withCallbacks({
      loadSportTypes:
        () =>
        async ({ search }) => {
          const sportTypes = toOptions(
            i18n.t('enum:sportType', { returnObjects: true })
          )

          if (!search) {
            return sportTypes
          }

          return sportTypes.filter(({ name }) => name.includes(search))
        },

      loadTournaments:
        ({ tournamentService }) =>
        async ({ search, sportType }) => {
          const params = await tournamentService.getTournamentsUpcomings({
            sportType,
            search,
          })
          return params.content || []
        },

      onSearchRequest: {
        deps: ['debounce', 'onSearch'],
        func: (_state, { debounce, onSearch }) => {
          return fp.isNumber(debounce)
            ? fp.debounce(debounce, onSearch)
            : onSearch
        },
      },
    }),

    withMobxAutorun(
      ({ firstRun, state: { form, onSearchRequest } }) => {
        const search = form.getControl('search')
        const linkedSportTournament = form.getControl('linkedSportTournament')
        const { sport, tournament } = linkedSportTournament.value
        const searchQuery = search.value

        if (firstRun) {
          return
        }

        onSearchRequest({
          search: searchQuery,
          tournamentId: tournament?.id,
          sport: sport?.id,
        })
      },
      ['onSearchRequest']
    ),
  ],
})(EventsFiltersComponent)
